import { faqAccordion } from './components/faqs';

(function (jQuery) {
	faqAccordion('.products--faqs-wrap', '.products--faq-question');
})(jQuery)